import Clickable from "@src/components/clickable"
import classnames from "@src/utils/classnames"
import React from "react"
import * as styles from "./guests.module.scss"
import { guests } from "./guests_data"

const Guests = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={classnames("intro", styles.intro)}>
          <div className={classnames("intro_body", styles.introBody)}>
            <h2>邀请嘉宾</h2>
            <div>
              <p>
                我们邀请了一些热爱并支持独立游戏的行业伙伴们，他们也将一起在此次活动中分享喜爱的作品
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.guestsContainer}>
        <div className={styles.guests}>
          {guests.map(({ name, img, desc, id }) => {
            return (
              <Clickable
                appNavTo={id ? `https://www.gcores.com/users/${id}` : undefined}
                disabled={id === null}
                key={name}
                className={styles.guest}
              >
                <div className={styles.guestImg}>
                  <img src={img} alt={name} />
                </div>
                <h3>{name}</h3>
                <div className={styles.guestDesc}>{desc}</div>
              </Clickable>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default Guests
